

// import React from 'react';
// import logoImage from './img/logoImage.jpg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faFacebookF, faTwitter, faPinterest, faYoutube } from '@fortawesome/free-brands-svg-icons';
// import { Row, Col, Container } from 'react-bootstrap';


// function Footer() {
//     return (
//         <div className='container-fluid footer-container'>
//             <div className='responsive-contain m-auto'>
//             <div className="f-items default-padding ">
//                 <Row>
//                     <Col>
//                         <div className="col-md-12 equal-height item">
//                             <div className="f-item">
//                                 <img src={logoImage} className="logo" alt="Logo" />
//                                 <p style={{color:'white'}}>
//                                     Lions Bhavan
//                                     Lakpath building
//                                     secunderabad
//                                 </p>
//                                 <div className="social">
//                                     <ul>
//                                         <li>
//                                             <a href="#">
//                                                 <FontAwesomeIcon icon={faFacebookF} />
//                                             </a>
//                                         </li>
//                                         <li>
//                                             <a href="#">
//                                                 <FontAwesomeIcon icon={faTwitter} />
//                                             </a>
//                                         </li>
//                                         <li>
//                                             <a href="#">
//                                                 <FontAwesomeIcon icon={faPinterest} />
//                                             </a>
//                                         </li>
//                                         <li>
//                                             <a href="#">
//                                                 <FontAwesomeIcon icon={faYoutube} />
//                                             </a>
//                                         </li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                     </Col>

//                     <Col>
//                         <div className="col-md-12 equal-height item ">
//                             <div className="f-item recent-post">
//                                 <h4>Important Links</h4>
//                                 <ul className="important-links-list">
//                                     <li>
//                                         <a href="#" target="_blank">President Theme</a>
//                                     </li>
//                                     <li>
//                                         <a href="#" target="_blank">Leadership Development Resource Center</a>
//                                     </li>
//                                     <li>
//                                         <a href="#" target="_blank">Club Resource Center</a>
//                                     </li>
//                                     <li>
//                                         <a href="#" target="_blank">District Resource Center</a>
//                                     </li>
//                                     <li>
//                                         <a href="#" target="_blank">Invite Members</a>
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </Col>

//                     <Col>
//                         <div className="col-md-12 equal-height item">
//                             <div className="f-item recent-post">
//                                 <h4>Important Links</h4>
//                                 <ul>
//                                     <li><a href="https://www.lionsclubs.org/en/search-results?keys=lions+internatonal+melvin+jones+memorial" target="_blank">Lions International Melvin Jones Memorial</a></li>
//                                     <li><a href="https://www.lionsclubs.org/en/resources-for-members/resource-center" target="_blank">Lions Club International Work</a></li>
//                                     <li><a href="https://www.lionsclubs.org/en/search-results?keys=lions+international+impact" target="_blank">Lions Club International Impact</a></li>
//                                     <li><a href="https://www.lionsclubs.org/en/search-results?keys=group+volunter+opportunities" target="_blank">Group Volunteer Oppurtunities</a></li>
//                                     <li><a href="https://www.lionsclubs.org/en/explore-our-clubs/our-global-causes" target="_blank">Global Health Programs</a></li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </Col>

//                     <Col>
//                         <div className="col-md-12 equal-height item">
//                             <div className="f-item recent-post">
//                                 <h4>Quick Links</h4>
//                                 <ul>
//                                     <li><a href="https://www.lionsclubs.org/en/discover-our-foundation/mission" target="_blank">LCIF</a></li>
//                                     <li><a href="https://www.lions-quest.org/" target="_blank">Lions Quest</a></li>
//                                     <li><a href="https://www.lionsclubs.org/en/resources-for-members/resource-center/create-e-district-house" target="_blank">E-club House In India</a></li>
//                                     <li><a href="https://www.lionsclubs.org/en/resources-for-members/top-25-searches" target="_blank">Latest Statistics</a></li>
//                                     <li><a href="https://www.lionsclubs.org/en/blog" target="_blank">Blogs to Governor</a></li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </Col>
//                 </Row>

//             </div>
//             <div className="footer-bottom  text-light">
//                 <Container>
//                     <hr className="my-4" />
//                     <Row className="align-items-center">
//                         <Col md={6} className='copy'>
//                             <p>© Copyright 2021. All Rights Reserved by <a href="#">emedha technologies</a></p>
//                         </Col>
//                         <Col md={6} className="text-right">
//                             <ul className="list-inline mb-0">
//                                 <li className="list-inline-item">
//                                     <a href="#">Terms of Use</a>
//                                 </li>
//                                 <li className="list-inline-item">
//                                     <a href="#">License</a>
//                                 </li>
//                                 <li className="list-inline-item">
//                                     <a href="#">Support</a>
//                                 </li>
//                             </ul>
//                         </Col>
//                     </Row>
//                 </Container>
//             </div>
//             </div>
//         </div>
//     );
// }

// export default Footer;











import logoImage from './img/logoImage.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { Row, Col, Container } from 'react-bootstrap';

function Footer() {
    return (
        <footer style={{ backgroundColor: '#002b49', color: '#f3f4f6', paddingTop: '60px', paddingBottom: '30px', fontFamily: 'inherit' }}>
            <Container>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    <Row style={{ rowGap: '40px' }}>

                        {/* Column 1: Logo, Address, Contact & Socials */}
                        <Col xs={12} sm={6} lg={3}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <img src={logoImage} alt="Logo" style={{ maxWidth: '140px', height: 'auto', objectFit: 'contain' }} />
                                <p style={{ color: '#d1d5db', fontSize: '14px', lineHeight: '1.6', margin: 0, whiteSpace: 'pre-line' }}>
                                    {`Lakpathi Building,\nBeside HDFC Bank,\nSecunderabad - 500003.\n\nMobile: +91-9866014575\nEmail: lionsmd320@gmail.com`}
                                </p>
                                <ul style={{ display: 'flex', gap: '10px', listStyle: 'none', padding: 0, margin: 0 }}>
                                    {[
                                        { icon: faFacebookF, link: "https://www.facebook.com/lionsmd320" },
                                        { icon: faYoutube, link: "https://www.youtube.com/@lionsmd320" },
                                        { icon: faInstagram, link: "https://www.instagram.com/lionsmd320" }
                                    ].map((social, idx) => (
                                        <li key={idx}>
                                            <a 
                                                href={social.link} 
                                                target="_blank" 
                                                rel="noreferrer" 
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#ffffff', borderRadius: '8px', textDecoration: 'none', transition: 'background-color 0.2s' }}
                                            >
                                                <FontAwesomeIcon icon={social.icon} style={{ fontSize: '14px' }} />
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                        {/* Column 2: Important Links */}
                        <Col xs={12} sm={6} lg={3}>
                            <div>
                                <h4 style={{ fontSize: '16px', fontWeight: 700, color: '#ffffff', marginBottom: '20px', borderLeft: '3px solid #FFD500', paddingLeft: '10px' }}>
                                    Important Links
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '14px' }}>
                                    {[
                                        { name: "President Theme", url: "#" },
                                        { name: "Leadership Development Resource Center", url: "#" },
                                        { name: "Club Resource Center", url: "#" },
                                        { name: "District Resource Center", url: "#" },
                                        { name: "Invite Members", url: "#" }
                                    ].map((item, idx) => (
                                        <li key={idx}>
                                            <a href={item.url} target="_blank" rel="noreferrer" style={{ color: '#d1d5db', textDecoration: 'none' }}>
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                        {/* Column 3: Lions International */}
                        <Col xs={12} sm={6} lg={3}>
                            <div>
                                <h4 style={{ fontSize: '16px', fontWeight: 700, color: '#ffffff', marginBottom: '20px', borderLeft: '3px solid #FFD500', paddingLeft: '10px' }}>
                                    Lions International
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '14px' }}>
                                    {[
                                        { name: "Lions International Melvin Jones Memorial", url: "https://www.lionsclubs.org/en/search-results?keys=lions+internatonal+melvin+jones+memorial" },
                                        { name: "Lions Club International Work", url: "https://www.lionsclubs.org/en/resources-for-members/resource-center" },
                                        { name: "Lions Club International Impact", url: "https://www.lionsclubs.org/en/search-results?keys=lions+international+impact" },
                                        { name: "Group Volunteer Opportunities", url: "https://www.lionsclubs.org/en/search-results?keys=group+volunter+opportunities" },
                                        { name: "Global Health Programs", url: "https://www.lionsclubs.org/en/explore-our-clubs/our-global-causes" }
                                    ].map((item, idx) => (
                                        <li key={idx}>
                                            <a href={item.url} target="_blank" rel="noreferrer" style={{ color: '#d1d5db', textDecoration: 'none' }}>
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                        {/* Column 4: Quick Links */}
                        <Col xs={12} sm={6} lg={3}>
                            <div>
                                <h4 style={{ fontSize: '16px', fontWeight: 700, color: '#ffffff', marginBottom: '20px', borderLeft: '3px solid #FFD500', paddingLeft: '10px' }}>
                                    Quick Links
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '14px' }}>
                                    {[
                                        { name: "LCIF", url: "https://www.lionsclubs.org/en/discover-our-foundation/mission" },
                                        { name: "Lions Quest", url: "https://www.lions-quest.org/" },
                                        { name: "E-club House In India", url: "https://www.lionsclubs.org/en/resources-for-members/resource-center/create-e-district-house" },
                                        { name: "Latest Statistics", url: "https://www.lionsclubs.org/en/resources-for-members/top-25-searches" },
                                        { name: "Blogs to Governor", url: "https://www.lionsclubs.org/en/blog" }
                                    ].map((item, idx) => (
                                        <li key={idx}>
                                            <a href={item.url} target="_blank" rel="noreferrer" style={{ color: '#d1d5db', textDecoration: 'none' }}>
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                    </Row>

                    {/* Footer Bottom Section */}
                    <hr style={{ borderColor: 'rgba(255, 255, 255, 0.15)', margin: '40px 0 20px 0' }} />
                    <Row style={{ alignItems: 'center', rowGap: '15px' }}>
                        <Col xs={12} md={6}>
                            <p style={{ fontSize: '13px', color: '#d1d5db', margin: 0, textAlign: 'left' }}>
                                © Copyright 2021. All Rights Reserved by <a href="#" style={{ color: '#FFD500', textDecoration: 'none' }}>emedha technologies</a>
                            </p>
                        </Col>
                        <Col xs={12} md={6}>
                            <ul style={{ display: 'flex', justifyContent: 'flex-start', listStyle: 'none', padding: 0, margin: 0, gap: '20px', fontSize: '13px' }}>
                                {["Terms of Use", "License", "Support"].map((linkText, idx) => (
                                    <li key={idx}>
                                        <a href="#" style={{ color: '#d1d5db', textDecoration: 'none' }}>{linkText}</a>
                                    </li>
                                ))}
                            </ul>
                        </Col>
                    </Row>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;